import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { AllGroupsPage } from '@features/groups/components/pages/AllGroupsPage'
import { ClassesTable } from '@features/groups/components/tables/ClassesTable'
import { groupsQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/all/classes')({
    component: RouteComponent,
    loader: async ({ context }) => {
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'all', type: 'class' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load classes'>
            <Suspense fallback={<LoadingIndicator resource='all classes'/>}>
                <AllGroupsPage
                    title='All classes'
                    renderTable={(columnPreset) => (
                        <ClassesTable
                            columnPreset={columnPreset}
                            mode='all'
                            navMode='id'
                        />
                    )}
                />
            </Suspense>
        </QueryErrorBoundary>
    )
}
